import { useState, useEffect } from "react";
import * as Yup from "yup";
import { char } from "../../../../utils";
import { Input, Loader, Message, useToaster } from "rsuite";
import { authCRUD } from "../../../../actions/auth";
import { selector } from "../../../../api";
import moment from "moment";
import { Select, Tag } from "antd";

const staffSchema = Yup.object().shape({
  email: Yup.string().matches(
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    "Please enter a valid email"
  ),
  phone_number: Yup.string().matches(
    /^255[1-9][0-9]{8}$/,
    "This field must start with 255 and be 12 digits long"
  ),
});

export const UserInfo = (props) => {
  const { dataId } = props;
  const user = selector.User();
  const [index, setIndex] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [dataSave, setDataSave] = useState({
    first_name: "",
    email: "",
    username: "",
    gender: "",
    phone_number: "",
  });
  const toaster = useToaster();

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        authCRUD
          .loadUserById(dataId)
          .then((resp) => {
            const item = resp.data[0];
            setData(item);
            setDataSave({
              first_name: item?.first_name || "",
              username: item?.username || "",
              email: item?.email || "",
              gender: item?.gender || "",
              phone_number: item?.phone_number || "",
            });
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId, index]);

  const handleActivate = () => {
    console.log("");
    
    // setLoading(true);
    // setTimeout(() => {
    //   authCRUD.postUserActivation(dataId).then(() => {
    //     setLoading(false);
    //     setIndex(index + 1);
    //     toaster.push(
    //       <Message type="success" showIcon header={"Success"} closable>
    //         <p className="h6 fs-14">
    //           <span className="fw-bold">Thank You</span>
    //           <br />
    //           <span className="text-dark">
    //             User status has been changed successfully..!
    //           </span>
    //           .
    //         </p>
    //       </Message>,
    //       { placement: "bottomEnd", duration: 7000 }
    //     );
    //   });
    // }, 500);
  };

  const handleChange = (field, value) => {
    setDataSave((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    if (field === "email") {
      staffSchema.fields.email
        .validate(value)
        .then(() => setEmailError("")) // valid → clear error
        .catch((err) => setEmailError(err.message)); // invalid → set error
    }

    if (field === "phone_number") {
      staffSchema.fields.phone_number
        .validate(value)
        .then(() => setPhoneError("")) // valid → clear error
        .catch((err) => setPhoneError(err.message)); // invalid → set error
    }
  };

  const handleSave = () => {
    setLoading(true);
    setTimeout(() => {
      authCRUD
        .updateUser(dataId, dataSave)
        .then(() => {
          toaster.push(
            <Message type="success" showIcon header={"Success"} closable>
              <p className="h6 fs-14">
                <span className="fw-bold">Thank You</span>
                <br />
                <span className="text-dark">
                  Region has been updated successfully
                </span>
                .
              </p>
            </Message>,
            { placement: "bottomEnd", duration: 7000 }
          );
          setIndex(index + 1);
          setLoading(false);
          setIsEdit(false);
        })
        .catch((error) => {
          setLoading(false);
          toaster.push(
            <Message type="error" showIcon header={"Error"} closable>
              <p className="h6 fs-14">
                <span className="fw-bold">Sorry...!</span>
                <br />
                <span className="text-dark">
                  Something went wrong. Please try again.
                </span>
                .
              </p>
            </Message>,
            { placement: "bottomEnd", duration: 7000 }
          );
        });
    }, 2000);
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <>
      <div className="card shadow border-red p-3">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh", // Full viewport height
              overflow: "hidden",
            }}
          >
            <Loader
              backdrop
              size="md"
              speed="slow"
              content="Please wait..."
              vertical
            />
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-md-2 col-sm-12 d-flex align-items-center">
                <p className="h6 mb-0">Full Name</p>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <p className="h6 fw-bold mb-0">:</p>
              </div>
              <div
                className={`${
                  isEdit ? "col-md-3 col-sm-12" : "col-md-6 col-sm-12"
                } d-flex align-items-center`}
              >
                <p className="h6 fw-bold mb-0">
                  {char.toTitleCase(data?.first_name)}
                </p>
              </div>
              {isEdit && (
                <div className="col-md-3 col-sm-12 d-flex align-items-center">
                  <Input
                    onChange={(e) => handleChange("first_name", e)}
                    className="form-control"
                    placeholder="Full Name"
                  />
                </div>
              )}
              {/* <div className="col-md-3 col-sm-12 d-flex justify-content-end align-items-center">
                {!isEdit ? (
                  <button
                    className="btn btn-light"
                    onClick={() => setIsEdit(!isEdit)}
                  >
                    <i className="bi bi-pencil-square" />
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => setIsEdit(!isEdit)}
                      type="button"
                      className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                    >
                      <i className="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                      Cancel
                    </button>
                    <button
                      onClick={handleSave}
                      type="button"
                      className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                      disabled={loading}
                    >
                      {!loading && (
                        <span className="indicator-label">
                          <i className="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                          Save
                        </span>
                      )}
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Please wait...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </>
                )}
              </div> */}
            </div>
            <hr />
            <div className="row">
              <div className="col-md-2 col-sm-12 d-flex align-items-center">
                <p className="h6">Gender</p>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <p className="h6 fw-bold">:</p>
              </div>
              <div
                className={`${
                  isEdit ? "col-md-3 col-sm-12" : "col-md-6 col-sm-12"
                } d-flex align-items-center`}
              >
                <p className="h6 fw-bold">{char.toTitleCase(data?.gender)}</p>
              </div>
              {isEdit && (
                <div className="col-md-3 col-sm-12 d-flex align-items-center">
                  <Select
                    size="large"
                    className="w-100"
                    showSearch
                    placeholder="Select gender"
                    optionFilterProp="children"
                    onChange={(e) => handleChange("gender", e)}
                    filterOption={filterOption}
                    options={[
                      { label: "Male", value: "male" },
                      { label: "Female", value: "female" },
                    ]}
                  />
                </div>
              )}
            </div>

            <hr />
            <div className="row">
              <div className="col-md-2 col-sm-12 d-flex align-items-center">
                <p className="h6">Email Address</p>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <p className="h6 fw-bold">:</p>
              </div>
              <div
                className={`${
                  isEdit ? "col-md-3 col-sm-12" : "col-md-6 col-sm-12"
                } d-flex align-items-center`}
              >
                <p className="h6 fw-bold">{data?.email}</p>
              </div>
              {isEdit && (
                <div className="col-md-3 col-sm-12 d-flex align-items-center">
                  <div className="form-group w-100">
                    <Input
                      onChange={(e) => {
                        handleChange("email", e);
                        handleChange("username", e);
                      }}
                      className="form-control w-100"
                      placeholder="Email Address"
                    />
                    {emailError && (
                      <span
                        className="text-danger mt-1"
                        style={{ fontSize: "13px" }}
                      >
                        {emailError}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col-md-2 col-sm-12 d-flex align-items-center">
                <p className="h6">Phone Number</p>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <p className="h6 fw-bold">:</p>
              </div>
              <div
                className={`${
                  isEdit ? "col-md-3 col-sm-12" : "col-md-6 col-sm-12"
                } d-flex align-items-center`}
              >
                <p className="h6 fw-bold">{data?.phone_number}</p>
              </div>
              {isEdit && (
                <div className="col-md-3 col-sm-12 d-flex align-items-center">
                  <div className="form-group w-100">
                    <Input
                      onChange={(e) => handleChange("phone_number", e)}
                      className="form-control w-100"
                      placeholder="Phone Number"
                    />
                    {phoneError && (
                      <div
                        className="fw-light mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        <span role="alert" className="text-danger">
                          {phoneError}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col-md-2 col-sm-12 d-flex align-items-center">
                <p className="h6">Last Login</p>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <p className="h6 fw-bold">:</p>
              </div>
              <div
                className={`${
                  isEdit ? "col-md-3 col-sm-12" : "col-md-6 col-sm-12"
                } d-flex align-items-center`}
              >
                <p className="h6 fw-bold">
                  {moment(data?.last_login).format(
                    "ddd, DD MMM YYYY : HH:mm:ss"
                  )}
                </p>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-2 col-sm-12 d-flex align-items-center">
                <p className="h6">Status</p>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <p className="h6 fw-bold">:</p>
              </div>
              <div
                className={`${
                  isEdit ? "col-md-3 col-sm-12" : "col-md-6 col-sm-12"
                } d-flex align-items-center`}
              >
                <p className="h6 fw-bold">
                  {data?.is_active ? (
                    <Tag color="#00c500" role="button" onClick={handleActivate}>
                      <i className="ri-check-double-fill" /> Active
                    </Tag>
                  ) : (
                    <Tag color="#ff2e2e" role="button" onClick={handleActivate}>
                      <i className="ri-close-circle-line" /> Not Active
                    </Tag>
                  )}
                </p>
              </div>
            </div>
            <hr />
          </>
        )}
      </div>
    </>
  );
};
